const TIER_STYLES = {
  enterprise: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  pro: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
};

const DEFAULT_TIER_STYLE = 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400';

const TIER_STYLES_MOBILE = {
  enterprise: 'bg-purple-100 text-purple-700',
  pro: 'bg-blue-100 text-blue-700',
};

const DEFAULT_TIER_STYLE_MOBILE = 'bg-gray-100 text-gray-700';

export const getTierStyle = (tier, mobile = false) => {
  if (mobile) return TIER_STYLES_MOBILE[tier] || DEFAULT_TIER_STYLE_MOBILE;
  return TIER_STYLES[tier] || DEFAULT_TIER_STYLE;
};

export const formatTierName = (tier) => {
  if (!tier) return '';
  return tier.charAt(0).toUpperCase() + tier.slice(1);
};

const SubscriptionTierBadge = ({ tier, mobile = false }) => {
  if (!tier) return null;

  return (
    <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${getTierStyle(tier, mobile)}`}>
      {formatTierName(tier)}
    </span>
  );
};

export default SubscriptionTierBadge;
